import { render } from "./AchievementImage.vue?vue&type=template&id=44e52a9e"
import script from "./AchievementImage.vue?vue&type=script&lang=js"
export * from "./AchievementImage.vue?vue&type=script&lang=js"

import "./AchievementImage.vue?vue&type=style&index=0&id=44e52a9e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__